import React, { Fragment } from 'react'

import { useNavbarTheme } from '../contexts/NavbarTheme'

import useInView from '../hooks/useInView'

import { media, rem } from '../styles/tools'

import SEO from '../components/SEO'
import Wrapper from '../components/Wrapper'
import Shell from '../components/Shell'
import Space from '../components/Space'
import Link from '../components/Link'
import BackgroundText from '../components/BackgroundText'
import ChallengeUsFooter from '../components/ChallengeUsFooter'
import { ContentAboveFooter } from '../components/Footer'
import { AutoSlide } from '../components/Animated'
import ShowCells from '../components/ShowCells'
import LogoCell from '../components/LogoCell'
import AwardCell from '../components/AwardCell'
import ScrollToLink from '../components/ScrollToLink'
import HelloFab from '../components/HelloFab'
import VerticalLine from '../components/VerticalLine'
import { Headline, BoldText, WideText } from '../styles/typography'

import webbyAwards from '../assets/awards/webby-awards.svg'
import addyAwards from '../assets/awards/addy-awards.svg'
import how from '../assets/awards/how.svg'
import W3Awards from '../assets/awards/W3-awards.svg'
import ava from '../assets/awards/ava.svg'
import commarts from '../assets/awards/commarts.svg'
import communicator from '../assets/awards/communicator.svg'
import davey from '../assets/awards/davey.svg'
import hermes from '../assets/awards/hermes.svg'
import horizon from '../assets/awards/horizon.svg'
import marcom from '../assets/awards/marcom.svg'
import webaward from '../assets/awards/webaward.svg'
import iac from '../assets/awards/iac.svg'
import sca from '../assets/awards/sca.svg'
import gdusa from '../assets/awards/gdusa.svg'
import ima from '../assets/awards/ima.svg'

export default () => {
  useNavbarTheme('dark')
  const [bottomRef, bottomInView] = useInView({ triggerOnce: false })

  return (
    <Fragment>
      <SEO title="Awards" />
      <Shell>
        <ContentAboveFooter>
          <Wrapper padded>
            <Space y={100} />
            <BackgroundText css={{ [media.max.tabletMd]: { display: 'none' } }}>
              AWARDS
            </BackgroundText>
            <AutoSlide
              left
              css={{
                [media.max.tabletMd]: { display: 'none' },
                marginTop: '-6.35vmax',
                marginLeft: rem(-5),
              }}
            >
              <Headline css={{ maxWidth: '13em' }}>
                Victories along the way
              </Headline>
            </AutoSlide>
            <Space y={{ tabletMd: 32 }} />
            <AutoSlide left delay={120}>
              <BoldText
                css={{
                  [media.max.tabletMd]: { display: 'none' },
                  width: '75%',
                }}
              >
                Sure we like shiny things, but the truth is winning awards is a
                testament to the dedication and passion of our craft.
              </BoldText>
            </AutoSlide>
            <Space y={64} />
            <ShowCells
              css={{
                display: 'grid',
                '--cols': 2,
                gridTemplateColumns: 'repeat(var(--cols), 1fr)',
                [media.tablet]: { '--cols': 4 },
                gridGap: 10,
                padding: 5,
              }}
            >
              <LogoCell>
                <AwardCell count={1}>
                  <img width="60%" src={webbyAwards} alt="Webby Awards logo" />
                </AwardCell>
              </LogoCell>
              <LogoCell>
                <AwardCell count={1}>
                  <img width="60%" src={addyAwards} alt="Addy Awards logo" />
                </AwardCell>
              </LogoCell>
              <LogoCell>
                <AwardCell count={1}>
                  <img width="60%" src={how} alt="How Awards logo" />
                </AwardCell>
              </LogoCell>
              <LogoCell>
                <AwardCell count={10}>
                  <img width="37%" src={W3Awards} alt="W3 Awards logo" />
                </AwardCell>
              </LogoCell>
              <LogoCell>
                <AwardCell count={1}>
                  <img width="60%" src={ava} alt="AVA logo" />
                </AwardCell>
              </LogoCell>
              <LogoCell>
                <AwardCell count={1}>
                  <img width="60%" src={commarts} alt="Commarts logo" />
                </AwardCell>
              </LogoCell>
              <LogoCell>
                <AwardCell count={10}>
                  <img width="60%" src={communicator} alt="communicator logo" />
                </AwardCell>
              </LogoCell>
              <LogoCell>
                <AwardCell count={5}>
                  <img width="60%" src={davey} alt="davey logo" />
                </AwardCell>
              </LogoCell>
              <LogoCell>
                <AwardCell count={3}>
                  <img width="60%" src={hermes} alt="hermes logo" />
                </AwardCell>
              </LogoCell>
              <LogoCell>
                <AwardCell count={5}>
                  <img width="60%" src={horizon} alt="horizon logo" />
                </AwardCell>
              </LogoCell>
              <LogoCell>
                <AwardCell count={2}>
                  <img width="60%" src={marcom} alt="marcom logo" />
                </AwardCell>
              </LogoCell>
              <LogoCell>
                <AwardCell count={2}>
                  <img width="40%" src={webaward} alt="webaward logo" />
                </AwardCell>
              </LogoCell>
              <LogoCell>
                <AwardCell count={1}>
                  <img width="60%" src={iac} alt="iac logo" />
                </AwardCell>
              </LogoCell>
              <LogoCell>
                <AwardCell count={3}>
                  <img width="60%" src={sca} alt="sca logo" />
                </AwardCell>
              </LogoCell>
              <LogoCell>
                <AwardCell count={1}>
                  <img width="37%" src={gdusa} alt="gdusa logo" />
                </AwardCell>
              </LogoCell>
              <LogoCell>
                <AwardCell count={7}>
                  <img width="53%" src={ima} alt="ima logo" />
                </AwardCell>
              </LogoCell>
            </ShowCells>
            <Space y={{ mobile: 80, tabletMd: 160 }} />
            <div
              ref={bottomRef}
              css={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <WideText as={Link} to="/work">
                SEE OUR WORK
              </WideText>
              <Space y={60} />
              <ScrollToLink
                href="#"
                css={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <svg style={{ width: 36, height: 36 }} viewBox="0 0 24 24">
                  <path
                    fill="#fff"
                    d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z"
                  />
                </svg>
                <Space y={20} />
                <VerticalLine animateToTop={bottomInView} />
              </ScrollToLink>
            </div>
          </Wrapper>
        </ContentAboveFooter>
        <ChallengeUsFooter />
        <HelloFab />
      </Shell>
    </Fragment>
  )
}
